import { useLocation } from "react-router-dom";
import MetaDescriptionAndKeywords from "./Metadescription";

const MetaRouteWrapper = () => {
  const location = useLocation();

  // normalize trailing slash
  const pathname =
    location.pathname !== "/" && location.pathname.endsWith("/")
      ? location.pathname.slice(0, -1)
      : location.pathname;

  return <MetaDescriptionAndKeywords pageLink={pathname} />;
};

export default MetaRouteWrapper;
